import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useOrganizationStore } from '@/store/useOrganizationStore';
import { useEntitlementsStore } from '@/store/useEntitlementsStore';
import { useUser } from '@/modules/viewer/composables/useUser';

export const useAddon = () => {
  const entitlementsStore = useEntitlementsStore();
  const organizationStore = useOrganizationStore();
  const { trial } = storeToRefs(organizationStore);
  const { isCurrentItemOwner } = useUser();

  const hasAiAddon = computed(() => {
    return isCurrentItemOwner.value && entitlementsStore.can('aiSummary');
  });

  const isAiAddonTrial = computed(() => {
    return trial?.value === true && entitlementsStore.can('aiSummary');
  });

  return { hasAiAddon, isAiAddonTrial };
};
